import React, { useState, useEffect } from 'react';
import Select from "react-select";

import { register } from '../types/authService';
import { getAssignToList } from '../types/api';
import '../style/Register.css';
import UserCreatedModal from './UserCreatedModal';

const Register: React.FC = () => {
  const [userId, setUserId] = useState('');
  const [parentId, setParentId] = useState('');
  const [password, setPassword] = useState('');
  const [firstName, setFirstName] = useState('');
  const [middleName, setMiddleName] = useState('');
  const [lastName, setLastName] = useState('');
  const [role, setRole] = useState('');
  const [mobileNumber, setMobileNumber] = useState('');
  const [email, setEmail] = useState('');

  // NEW FIELD (multi-select business group)
  const [businessGroups, setBusinessGroups] = useState<string[]>([]);

  const [error, setError] = useState('');
//  const [alert, setAlert] = useState('');
  const [loading, setLoading] = useState<boolean>(false);
  const [showModal, setShowModal] = useState(false);
//  const [showPopup, setShowPopup] = useState(false);

  const [registeredUser, setRegisteredUser] = useState<{
    userName: string;
    password: string;
    mobileNumber: string;
  } | null>(null);

  const userRole = localStorage.getItem('role');

  // Business Group Options
  const businessGroupOptions = [
    { value: "Agriculture", label: "Agriculture" },
    { value: "Beauty", label: "Beauty" },
    { value: "Business", label: "Business" },
    { value: "Health & Fitness", label: "Health & Fitness" },
    { value: "MLM", label: "MLM" },
    { value: "Student", label: "Student" },
    { value: "Women", label: "Women" }
  ];

  const [users, setUsers] = useState<
    { id: string; userName: string; mobileNumber: string }[]
  >([]);

  useEffect(() => {
    getAssignToList().then(setUsers).catch(() => setError("Failed to load users"));
    
    setUserId('');
    setParentId('');
    setFirstName('');
    setMiddleName('');
    setLastName('');
    setPassword('');
    setRole('');
    setMobileNumber('');
    setEmail('');
    setBusinessGroups([]);
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      setLoading(true);
      console.log(businessGroups);
      const data = await register(
        userId,
        parentId,
        password,
        firstName,
        middleName,
        lastName,
        role,
        mobileNumber,
        email,
        businessGroups   // <-- NEW FIELD SENT TO API
      );
       
      //setAlert(`Registered ` + data.userName + `/` + data.password +  `/${mobileNumber}`);

    setRegisteredUser({
      userName: data.userName,
      password: data.password,
      mobileNumber: mobileNumber
    });
    setShowModal(true);

      // Reset fields
      setError('');
      setUserId('');
      setParentId('');
      setFirstName('');
      setMiddleName('');
      setLastName('');
      setPassword('');
      setRole('');
      setMobileNumber('');
      setEmail('');
      setBusinessGroups([]);

      try {
        getAssignToList().then(setUsers).catch(() => setError("Failed to load users"));
      } catch  (err) {
        console.log(err);
      }      
    } catch (err) {
      setError('Registration failed');
    } finally {
      setLoading(false);
    }
  };

  // Role map
  const roleMap: { [key: string]: string } = {
    ADMIN: 'Admin',
    EDITOR: 'Editor',
    VIEWER: 'Viewer'
  };

  // Role options based on logged-in user role
  const roleOptions =
    userRole === 'ADMIN'
      ? ['ADMIN', 'EDITOR', 'VIEWER']
      : userRole === 'EDITOR'
        ? ['EDITOR', 'VIEWER']
        : ['VIEWER'];

   return (
    <div className="div-container">
      <h2>Register</h2>
      <form onSubmit={handleSubmit}>
        {/*
        <input
          type="text"
          placeholder="Username"
          value={userId}
          onChange={(e) => setUserId(e.target.value)}
          
        />
        */}
        <input
          type="text"
          placeholder="First Name"
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
          required
        />
        <input
          type="text"
          placeholder="Middle Name"
          value={middleName}
          onChange={(e) => setMiddleName(e.target.value)}
        />
        <input
          type="text"
          placeholder="Last Name"
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <input
          type="text"
          placeholder="+91XXXXXXXXXX or 9XXXXXXXXX"
          value={mobileNumber}
          onChange={(e) => setMobileNumber(e.target.value)}
          required
        />
        <input
          type="email"
          className="otp-input"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        {/* ROLE SELECT */}
        <select
          value={role}
          onChange={(e) => setRole(e.target.value)}
          required
        >
          <option value="" disabled>Select Role</option>
          {roleOptions.map((key) => (
            <option key={key} value={key}>
              {roleMap[key]}
            </option>
          ))}
        </select>

        <select
          value={parentId}
          onChange={(e) => setParentId(e.target.value)}
          
        >
          <option value="">-- Select Ancestor --</option>
          {users.map((u) => (
            <option key={u.userName} value={u.userName}>
              {u.userName} - {u.mobileNumber}
            </option>
          ))}
        </select>
        {/* NEW BUSINESS GROUP MULTI-SELECT */}
        <Select
          isMulti
          options={businessGroupOptions}
          value={businessGroupOptions.filter(opt => businessGroups.includes(opt.value))}
          onChange={(selected) =>
            setBusinessGroups(selected ? selected.map((s) => s.value) : [])
          }
          placeholder="Select Business Groups"
        />
        
        <button type="submit">
          {loading ? 'Inprogress...' : 'Register'}
        </button>
        {error && <p style={{ color: 'red' }}>{error}</p>}
       
        <UserCreatedModal
          open={showModal}
          data={registeredUser}
          onClose={() => setShowModal(false)}
          autoCloseSeconds={60}
          locale="en"
          onAuditLog={(data) => {
            console.log("AUDIT LOG:", data);
            // call backend API here
          }}
        />


      </form>
      


    </div>
  );
};

export default Register;
